import store from '@/store';

export default shields => {
  const { core: { pages, pagesSelection } } = store.getState();
  const currentPage = pages[pagesSelection[0]];
  const shieldsIds = Object.keys(shields);
  const sections = Object.values(currentPage.sections).reduce((acc, section) => {
    if (shieldsIds.includes(section.shieldId)) {
      return { ...acc, [section.id]: section };
    }
    return acc;
  }, {});

  return sections;
};
